<template>
  <section id="collaboration" class="collaboration-container">
    <h2>Collaboration & Tools</h2>
    <p class="section-desc">
      원활한 소통과 투명한 진행 상황 공유는 성공적인 프로젝트의 핵심이라고
      생각합니다.<br />
      다양한 협업 툴을 적극적으로 활용하여 팀의 시너지를 극대화합니다.
    </p>
    <div class="tools-grid">
      <div class="tool-card">
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original.svg"
          alt="GitHub Logo"
        />
        <h3>GitHub</h3>
        <p>
          Git-Flow 전략을 기반으로 Pull Request를 통한 코드 리뷰 및 버전 관리를
          진행합니다.
        </p>
      </div>
      <div class="tool-card">
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/notion/notion-original.svg"
          alt="Notion Logo"
        />
        <h3>Notion</h3>
        <p>
          API 명세서, 프로젝트 진행 상황, 회의록 등 모든 문서를 체계적으로
          관리하고 공유합니다.
        </p>
      </div>
      <div class="tool-card">
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/slack/slack-original.svg"
          alt="Slack Logo"
        />
        <h3>Slack</h3>
        <p>
          주요 공지, 빠른 질의응답 등 목적에 맞는 채널을 활용하여 효율적으로
          소통합니다.
        </p>
      </div>
      <div class="tool-card">
        <img
          src="https://raw.githubusercontent.com/devicons/devicon/master/icons/figma/figma-original.svg"
          alt="Figma Logo"
        />
        <h3>Figma</h3>
        <p>
          디자이너와 개발자 간의 원활한 협업을 위해 디자인 시안을 이해하고
          의견을 교환합니다.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CollaborationSection",
};
</script>
<style scoped>
.collaboration-container {
  padding: 100px 5%;
  text-align: center;
  background-color: var(--bg-secondary-color);
}
h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
}
.section-desc {
  font-size: 1.1rem;
  color: var(--text-secondary-color);
  max-width: 700px;
  margin: 0 auto 50px auto;
  line-height: 1.7;
}
.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}
.tool-card {
  background: var(--bg-color);
  border: 1px solid var(--card-border-color);
  border-radius: 15px;
  padding: 30px;
  transition: all 0.3s ease;
}
.tool-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 30px var(--card-shadow-color);
}
.tool-card img {
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
}
.tool-card h3 {
  font-size: 1.3rem;
  color: var(--text-primary-color);
  margin: 0 0 10px 0;
}
.tool-card p {
  font-size: 0.95rem;
  color: var(--text-secondary-color);
  line-height: 1.6;
}

@media (max-width: 768px) {
  .collaboration-container {
    padding: 60px 5%;
  }
}
</style>
